import React, { useState, Fragment } from 'react'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { Expaned, Row, Column } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import './goods-detail.scss'
import { layerManage } from '@/utils/layer'
import Iconfont from '@/components/iconfont/iconfont'
import { $post } from '@/api'
import { useRequest, useMount } from 'ahooks'
import { Spin } from 'antd'
import { getQiniuImgUrl } from '@/config/qiniu'
import classNames from 'classnames'
import { IMallGoods } from '@/model/types/mall'
import 'react-quill/dist/quill.snow.css'
import { intervalPrice, intervalMemberPrice } from '@/utils/goods'
import DetailForm, { IDetailGoods } from './modules/detail-form/detail-form'
import { PricesBox } from '@/views/main/modules/goods-manage/components/prices/prices-box/prices-box'
import { goodsModel } from '@/views/main/modules/goods-manage/goods-storage/goods-library/modules/edit-goods/modules/model'
interface IProps {
    goodsId: number
    onChange: () => void
}

export const MallGoodsDetail: React.FC<IProps> = props => {
    const cls = (...args: string[]) => getBEMCls('goods-detail', ...args)
    const [goodsInfo, setGoodsInfo] = useState<IMallGoods>()
    const [isShowPricesBox, setIsShowPricesBox] = useState(false)
    const [detailForm, setDetailForm] = useState<IDetailGoods | null>(null)

    useMount(() => {
        goodsModel.getGenerateCode(true)
    })

    const { loading } = useRequest(
        () =>
            $post({
                url: '/mall/getmallgoods',
                params: {
                    mall_goods_id: props.goodsId,
                },
            }),
        {
            onSuccess: res => {
                const goodInfo = res.mall_goods_list[0]
                setGoodsInfo(goodInfo)
                setDetailForm({
                    goods: goodInfo.goods,
                    mall_goods_images: goodInfo.mall_goods_images,
                    stock: goodInfo.stock,
                    title: goodInfo.title || goodInfo.goods.name,
                    goods_brief: goodInfo.goods_brief,
                    content: goodInfo.content,
                    pricing_methods: goodInfo.pricing_methods.map((i: any) => ({
                        ...i,
                        mall_display: {
                            underline_price: i.mall_display?.underline_price ?? '',
                        },
                        member_price: Object.keys(i.member_price).length
                            ? i.member_price
                            : {
                                  sale_price: '',
                                  amount_limit: '',
                                  sale_unit: {
                                      id: 2,
                                      name: '斤',
                                      status: 0,
                                  },
                              },
                    })),
                    sales_unit: goodInfo.goods.stock_unit,
                    negative_stock_mode: goodInfo.negative_stock_mode,
                })
            },
        },
    )

    return (
        <BaseDrawer
            isShow
            title="商城商品详情"
            onClose={() => {
                layerManage.pop()
            }}
        >
            <Column data-height-100p>
                <Spin spinning={loading} style={{ height: 'calc(100%)', display: 'flex' }} data-center-center></Spin>
                {goodsInfo && (
                    <Expaned style={{ overflow: 'scroll' }}>
                        {/* 商品标题 */}
                        <div className={cls('goods-info')}>
                            <div className={cls('goods-info', 'avatar')}>
                                <img src={getQiniuImgUrl(goodsInfo.goods.img_url)} alt="" />
                            </div>
                            <Row className={cls('goods-info', 'title')}>
                                <div className={classNames(cls('goods-info', 'name'), 'text-popper')}>
                                    {goodsInfo.title || goodsInfo.goods.name}
                                </div>
                            </Row>
                            {/* 只有一种计价方式  */}
                            {goodsInfo.goods.pricing_methods.length === 1 ? (
                                goodsInfo.goods.pricing_methods[0].sale_prices.length === 1 ? (
                                    // 单售价不含阶梯价
                                    <Fragment>
                                        <Row data-margin-top-16>
                                            <div className={cls('goods-info', 'price')}>
                                                <div className="">
                                                    <span data-font-size-14>¥</span>
                                                    <span data-font-size-20>
                                                        {goodsInfo.goods.pricing_methods[0].sale_prices[0].sale_price}
                                                    </span>
                                                    <span data-font-size-14 data-font-weight-400>
                                                        /{goodsInfo.goods.pricing_methods[0].sales_unit.name}
                                                    </span>
                                                </div>
                                            </div>
                                            {goodsInfo.goods.pricing_methods[0].member_price.sale_price > 0 && (
                                                <div className={cls('goods-info', 'memberPrice')}>
                                                    <Iconfont name="icon8huiyuanjia-12" size={18}></Iconfont>
                                                    <span data-font-size-14 data-margin-left-5>
                                                        ¥
                                                    </span>
                                                    <span data-font-size-20>
                                                        {goodsInfo.goods.pricing_methods[0].member_price.sale_price}
                                                    </span>
                                                    <span data-font-size-14 data-font-weight-400>
                                                        /{goodsInfo.goods.pricing_methods[0].sales_unit.name}
                                                    </span>
                                                </div>
                                            )}
                                        </Row>
                                        {/* 计价说明 */}
                                        <Row data-font-size-14 data-color-999 data-margin-top-5>
                                            {goodsInfo.goods.pricing_methods[0].sales_unit_ratio > 1 && (
                                                // tslint:disable-next-line:max-line-length
                                                <div>
                                                    一{goodsInfo.goods.stock_unit.name}=
                                                    {goodsInfo.goods.pricing_methods[0].sales_unit_ratio}
                                                    {goodsInfo.goods.pricing_methods[0].sales_unit.name}
                                                </div>
                                            )}
                                            <div data-margin-left-10>
                                                {goodsInfo.goods.pricing_methods[0].price_annotation}
                                            </div>
                                        </Row>
                                    </Fragment>
                                ) : (
                                    // 含阶梯价
                                    <Fragment>
                                        <Row
                                            data-margin-top-16
                                            className={cls('goods-info', 'hover')}
                                            onClick={() => setIsShowPricesBox(!isShowPricesBox)}
                                        >
                                            <div className={classNames(cls('goods-info', 'price'))}>
                                                <div className="">
                                                    <span data-font-size-14>¥</span>
                                                    <span data-font-size-20>
                                                        {intervalPrice(goodsInfo.goods.pricing_methods).min}~
                                                        {intervalPrice(goodsInfo.goods.pricing_methods).max}
                                                    </span>
                                                </div>
                                            </div>
                                            {goodsInfo.goods.pricing_methods[0].member_price.sale_price > 0 && (
                                                <div className={cls('goods-info', 'memberPrice')}>
                                                    <Iconfont name="icon8huiyuanjia-12" size={18}></Iconfont>
                                                    <span data-font-size-14 data-margin-left-5>
                                                        ¥
                                                    </span>
                                                    <span data-font-size-20>
                                                        {goodsInfo.goods.pricing_methods[0].member_price.sale_price}
                                                    </span>
                                                </div>
                                            )}
                                            <Row data-margin-left-5 data-align-items-center>
                                                <Iconfont
                                                    name={isShowPricesBox ? 'icon6xiala2-20-copy' : 'icon6xiala2-20'}
                                                    size={16}
                                                ></Iconfont>
                                            </Row>
                                        </Row>
                                    </Fragment>
                                )
                            ) : (
                                <Fragment>
                                    <Row
                                        data-margin-top-16
                                        className={cls('goods-info', 'hover')}
                                        onClick={() => setIsShowPricesBox(!isShowPricesBox)}
                                    >
                                        <div className={classNames(cls('goods-info', 'price'))}>
                                            <div className="">
                                                <span data-font-size-14>¥</span>
                                                <span data-font-size-20>
                                                    {intervalPrice(goodsInfo.goods.pricing_methods).min}~
                                                    {intervalPrice(goodsInfo.pricing_methods).max}
                                                </span>
                                            </div>
                                        </div>
                                        {intervalMemberPrice(goodsInfo.goods.pricing_methods).length > 0 && (
                                            <div className={cls('goods-info', 'memberPrice')}>
                                                <Iconfont name="icon8huiyuanjia-12" size={18}></Iconfont>
                                                <span data-font-size-14 data-margin-left-5>
                                                    ¥
                                                </span>
                                                <span data-font-size-20>
                                                    {intervalMemberPrice(goodsInfo.goods.pricing_methods).min}~
                                                    {intervalMemberPrice(goodsInfo.goods.pricing_methods).max}
                                                </span>
                                            </div>
                                        )}
                                        <Row data-margin-left-5 data-align-items-center>
                                            <Iconfont
                                                name={isShowPricesBox ? 'icon6xiala2-20-copy' : 'icon6xiala2-20'}
                                                size={16}
                                            ></Iconfont>
                                        </Row>
                                    </Row>
                                </Fragment>
                            )}
                            {/*多种计价方式 */}
                            {isShowPricesBox && (
                                <PricesBox
                                    pricing_methods={
                                        goodsInfo.pricing_methods.length > 0
                                            ? goodsInfo.pricing_methods
                                            : goodsInfo.goods.pricing_methods
                                    }
                                    goods={goodsInfo.goods}
                                ></PricesBox>
                            )}
                        </div>

                        <DetailForm goodId={goodsInfo.id} detail={detailForm} />
                    </Expaned>
                )}
            </Column>
        </BaseDrawer>
    )
}
